import { Employer } from 'services/requests';
import TableSorting from 'components/Table/TableElements/TableSorting';
import { CustomColumn } from 'components/Table/Table.types';
import EmployersEditButton from './components/EmployersEditButton';

import messages from './Employers.messages';
import styles from './Employers.module.css';

export type MapData = EmployerTableSign[];

export type EmployerTableSign = Employer & {
  icon: JSX.Element;
  employerType: string;
};

export const mapData = (
  data: Employer[] | undefined,
  onEdit: (employer: Employer) => void,
): MapData | undefined =>
  data?.map((employer: Employer) => ({
    ...employer,
    employerType: !employer.isFreelancer ? messages.multipleEmployeesType : '',
    icon: <EmployersEditButton employer={employer} onEdit={onEdit} />,
  }));

export const columns: CustomColumn<EmployerTableSign>[] = [
  {
    Header: <TableSorting sortingFieldKey={'name'} sortingFieldName={'Name'} />,
    accessor: 'name',
    className: styles.nameColumn,
  },
  {
    Header: 'Type',
    accessor: 'employerType',
  },
  {
    Header: 'Employees',
    accessor: 'employerUsersCount',
  },
  {
    Header: '',
    accessor: 'icon',
    className: styles.iconColumn,
  },
];
